import styled from 'styled-components';

import type { Appointment, Universe } from '@wecasa/common/src/types/commons';
import { formatPrimaryAppointmentDeprecated } from '@wecasa/common/src/utils/appointment';
import colors, { withOpacity } from '@wecasa/common/src/utils/colors';
import { toRem } from '@wecasa/common/src/utils/styles';

import { translate } from '@wecasa/i18n';

import Accordion from '@wecasa/web-ui/src/components/accordion/accordion';
import Text from '@wecasa/web-ui/src/components/base-text/variants/text';
import Separator from '@wecasa/web-ui/src/components/separator/separator';

import useBasketSection from '../../../../../hooks/use-basket-section';
import {
  APPOINTMENT_CALENDAR_PATH,
  APPOINTMENT_DAY_PATH,
  APPOINTMENT_HOUR_PATH,
  route,
} from '../../../../../steps/steps';
import AppointmentDetails from './appointment-details';

const t = translate('basket');

const StyledAccordion = styled(Accordion)`
  margin: ${toRem(20)} 0;
`;

type AppointmentsProps = {
  universe: Universe;
  appointment: Appointment;
};

const Appointments = ({ universe, appointment }: AppointmentsProps) => {
  const { primary, secondary } = appointment;
  const { isOpen, isVisible, hasData } = useBasketSection({
    data: !!primary,
    sectionLocations: [route(APPOINTMENT_DAY_PATH), route(APPOINTMENT_CALENDAR_PATH), route(APPOINTMENT_HOUR_PATH)],
  });

  const title = primary ? formatPrimaryAppointmentDeprecated(primary) : t('.primary_appointment.title.default');

  const subtitle = secondary.length ? (
    <Text.SM>{t('.secondary_appointment', { count: secondary.length })}</Text.SM>
  ) : undefined;

  if (!isVisible) return null;

  return (
    <>
      <Separator />
      <StyledAccordion
        icon='clock-filled'
        iconLabel={t('.appointment_icon_label')}
        title={title}
        subtitle={subtitle}
        isOpen={isOpen}
      >
        {!hasData ? (
          <Text.SM color={withOpacity(colors.neutral100, 0.5)}>
            {t('.primary_appointment.not_selected_yet.text', {
              universe: t(`.primary_appointment.not_selected_yet.universe.${universe.reference}`),
            })}
          </Text.SM>
        ) : (
          <AppointmentDetails appointment={appointment} />
        )}
      </StyledAccordion>
    </>
  );
};

export default Appointments;
